import { createAsyncThunk } from "@reduxjs/toolkit";
import { DocumentService, ReqViewService } from "../../../../api";

export const getPage = createAsyncThunk("notesPdf/getPage", ({ docId, page, token }) =>
	DocumentService.getPage({ docId }, { page }, token)
);
export const getMetadata = createAsyncThunk("notesPdf/getMetadata", ({ docId, page, token }) =>
	ReqViewService.getContents({ docId }, { page }, token)
);
